module.exports = __webpack_public_path__ + "img/accounts.d86228fe.svg";